import { client } from '../apiClient';

const USER_ENDPOINT = '/user';

type ChartSettings = {
  displayMarkers?: boolean;
};

type PanelSettingsResponse = {
  charts?: Record<string, ChartSettings>;
};

type PatchPanelSettingsResponse = {
  message?: string;
};

export const changeActiveAccount = async (
  id: number
): Promise<{
  success: boolean;
  requiresRelogin: boolean;
}> => {
  return client(true, true)
    .get<{
      success: boolean;
      requiresRelogin: boolean;
    }>(`${USER_ENDPOINT}/change-account/${id}`)
    .then((response) => response.data);
};

export const getPanelSettings = async (): Promise<PanelSettingsResponse> => {
  const { data } = await client(true, true).get<PanelSettingsResponse>(`${USER_ENDPOINT}/panel-settings`);
  return data ?? {};
};

export const patchPanelSetting = async (
  section: string,
  config: string,
  payload: Record<string, unknown>
): Promise<boolean> => {
  const { data } = await client(true, true).patch<PatchPanelSettingsResponse>(
    `${USER_ENDPOINT}/panel-settings/${section}/${config}`,
    payload
  );
  return data?.message === 'ok';
};
